import React from 'react';
import { Faq, Question } from '@luckycart/xpn-types';
import parse from 'html-react-parser';

import {
  FaqTitle,
  QuestionTitle,
  StyledCollapse,
  StyledPanel,
  StyledChevronIcon,
} from './Faq.style';
import { removeBreaksAndEmptyParagraphs } from '../../utils/removeBreaksAndEmptyParagraphs';

export type FaqProps = { faq: Faq | undefined };

const AppFaq: React.FC<FaqProps> = (props: FaqProps) => {
  const questions = props.faq?.questions.map((question: Question) => {
    return (
      <StyledPanel
        header={<QuestionTitle>{question.question}</QuestionTitle>}
        key={`${question.question}-${question.answer.slice(0, 20)}`}
      >
        {parse(removeBreaksAndEmptyParagraphs(question.answer))}
      </StyledPanel>
    );
  });
  return (
    <>
      <FaqTitle>{props.faq?.title}</FaqTitle>
      <StyledCollapse
        accordion
        bordered={false}
        expandIconPosition="end"
        expandIcon={({ isActive }) => (
          <StyledChevronIcon $isActive={isActive === true}>
            <polyline points="6 9, 12 15, 18 9" />
          </StyledChevronIcon>
        )}
        className="site-collapse-custom-collapse"
      >
        {questions}
      </StyledCollapse>
    </>
  );
};
export default AppFaq;
